import React from 'react';

import LoginForm from '../LoginForm/LoginForm';

const env = require("../../config.js").default;
const common = require('../common/common');

class Login extends React.Component {
  componentDidMount(){
    document.title = env.APP_NAME + " - Login";
    document.getElementById('body').className='login_page';
    common.remove_localStorage('modelli');

  }
  constructor(props) {
    super(props);
    this.state = {};
    this.state.isLoggedIn = false;
    this.state.user = "";
  }

  render(props){
    if(!this.state.isLoggedIn || this.state.user === ""){
      if(env.BACKEND_LOGIN_GRANT_TYPE === "authorization-code"){
        var state = "";
        var nonce = Math.random().toString(36).substring(2).toString(); //Random nonce generation
        state = nonce + common.nonceSeparator + window.location.href;
        state = btoa(state);
        common.set_sessionStorage("sw_oauth2_state", state);
        window.location.href = env.LOGIN_BACKEND + "o/authorize/?redirect_uri=" + env.FRONTEND + "login-complete&client_id=" + env.BACKEND_LOGIN_CLIENT_ID + "&response_type=code&state=" + state;
        return false;
      }else if(env.BACKEND_LOGIN_GRANT_TYPE === "password"){
        return(<LoginForm></LoginForm>);
      }
    }else{
      return(
        <div>
          Benvenuto
        </div>
      )
    }
  }
}


export default Login;
